import { render } from "./MiniWizardExpandable.vue?vue&type=template&id=a8ef390c"
import script from "./MiniWizardExpandable.vue?vue&type=script&lang=js"
export * from "./MiniWizardExpandable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__